import React, { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'About',       href: '#about' },
  { label: 'Skills',      href: '#skills' },
  { label: 'Experience',  href: '#experience' },
  { label: 'Achievements',href: '#achievements' },
  { label: 'Contact',     href: '#contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <a
          href="#hero"
          className="nav-logo"
          onClick={(e) => scrollTo(e, '#hero')}
        >
         <span className="nav-logo__bracket">&lt;</span>
         <span className="nav-logo__initial">M</span>
         <span className="nav-logo__bracket">/&gt;</span>
        </a>

        <ul className="nav-links">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a href={link.href} onClick={(e) => scrollTo(e, link.href)}>
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="/Resume.pdf"
              download
              className="nav-cta"
            >
              ⬇ Resume
            </a>
          </li>
        </ul>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        {NAV_LINKS.map((link) => (
          <a key={link.href} href={link.href} onClick={(e) => scrollTo(e, link.href)}>
            {link.label}
          </a>
        ))}
        <a href="/Resume.pdf" download style={{ color: 'var(--amber)' }}>
          ⬇ Download Resume
        </a>
      </div>
    </>
  );
}
